/* Anchor links — RYF theme utility.
   Smooth-scroll helpers for section-to-section links set in the editor
   or template JSON, without hard-coding runtime section IDs:

     href="#next-section"        → scrolls to the section after the one
                                   containing the link
     href="#section-<key>"       → scrolls to the section whose template
                                   key (the stable key in the template
                                   JSON, e.g. "social_proof_main") or
                                   section class suffix matches <key>

   Scroll position accounts for the sticky header; reduced-motion users
   get an instant jump. */

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#next-section"], a[href^="#section-"]');
  if (!link) return;

  const href = link.getAttribute('href');
  let target = null;

  if (href === '#next-section') {
    const section = link.closest('.shopify-section');
    target = section && section.nextElementSibling;
  } else {
    const key = href.slice('#section-'.length);
    if (key) {
      target =
        document.querySelector('.shopify-section[id$="__' + CSS.escape(key) + '"]') ||
        document.querySelector('.shopify-section--' + CSS.escape(key));
    }
  }

  if (!target) return;
  event.preventDefault();

  if (!target.style.scrollMarginBlockStart) {
    target.style.scrollMarginBlockStart = 'calc(var(--sticky-area-height, 0px) + 0.5rem)';
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
});
